import useGetListOfMatriculas from '../../globalHooks/matricula/use-get-list-of-matriculas.hook';

export default function useCalendar() {
	const { currentContractEnrollments } = useGetListOfMatriculas({});

	return {
		currentContractEnrollments,
	};
}
